export default "__VITE_ASSET__DB4Gaq6j__"